<header class="agricola-navbar">
  <div class="navbar-left">
    <button
      #menuButton
      class="hamburger-menu"
      type="button"
      aria-label="Menú"
      aria-controls="sis-drawer"
      [attr.aria-expanded]="menuOpen"
      (click)="toggleMenu()"
      [class.active]="menuOpen">
      <img src="assets/agricola/menu.svg" alt="" aria-hidden="true" />
    </button>
    <button type="button" class="system-name" (click)="goHome()">Sistema integral de seguros</button>
  </div>
  <div class="navbar-right">
    <button class="quick-guide" type="button" (click)="openQuickGuide()">
      <img src="assets/agricola/header-guia.svg" alt="" aria-hidden="true" />
      <span>Guía rápida</span>
    </button>
    <div class="user-menu-container">
      <button
        class="user-menu"
        type="button"
        aria-label="Menú de usuario"
        aria-controls="profile-menu"
        [attr.aria-expanded]="userMenuOpen"
        (click)="toggleUserMenu()">
        <img src="assets/agricola/header-user.svg" alt="" aria-hidden="true" />
        <span>{{ userName$ | async }}</span>
        <img src="assets/agricola/field-chevron.svg" alt="" aria-hidden="true" />
      </button>
      <div id="profile-menu" class="profile-menu" *ngIf="userMenuOpen" role="menu">
        <button type="button" class="profile-menu-item" role="menuitem" (click)="logout()">
          <img src="assets/agricola/cerrar-sesion.svg" alt="" aria-hidden="true" />
          <span>Cerrar sesión</span>
        </button>
      </div>
    </div>
  </div>
</header>

<!-- Sidebar -->
<button
  class="sidebar-overlay"
  type="button"
  *ngIf="menuOpen"
  aria-label="Cerrar menú"
  (click)="closeAllMenus()">
</button>
<nav id="sis-drawer" class="sidebar" [class.open]="menuOpen" aria-label="Navegación principal">
  <div class="sidebar-menu">
    <div class="menu-items-container">
      <button
        type="button"
        class="menu-item" 
        *ngFor="let item of menuItems" 
        [class.active]="item.active"
        [class.has-submenu-open]="item.expanded"
        [attr.aria-expanded]="item.submenu?.length ? item.expanded : null"
        (click)="toggleSubmenu(item, $event)">
        <div class="menu-item-content">
          <img [src]="item.icon" alt="" aria-hidden="true" class="menu-icon" />
          <span>{{ item.label }}</span>
          <img src="assets/agricola/field-chevron.svg" alt="" aria-hidden="true" class="menu-arrow" />
        </div>
      </button>
    </div>
  </div>
</nav>

<!-- Submenu Panel -->
<div class="submenu-panel" *ngIf="menuOpen && hasSubmenuOpen()" [class.open]="hasSubmenuOpen()" [style.left.px]="sidebarWidth" [style.top.px]="expandedItemTop + 64">
  <div class="submenu-header" *ngIf="getExpandedItem()">
    <button class="close-submenu" type="button" aria-label="Cerrar submenú" (click)="closeSubmenu()">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>
    <span class="submenu-title">{{ getExpandedItem()?.label }}</span>
  </div>
  <div class="submenu-content" *ngIf="getExpandedSubmenu().length > 0">
    <button
      type="button"
      class="submenu-item" 
      *ngFor="let subitem of getExpandedSubmenu()"
      (click)="onSubmenuClick(subitem, $event)">
      {{ subitem.label }}
    </button>
  </div>
</div>
